import script from "./commonFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./commonFooter.vue?vue&type=script&setup=true&lang=js"

import "./commonFooter.vue?vue&type=style&index=0&id=580cda24&lang=scss&scoped=true"

import exportComponent from "D:\\zwy\\sdt\\云服务器租赁\\node_modules\\_vue-loader@17.0.1@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-580cda24"]])

export default __exports__